module.exports = __webpack_public_path__ + "static/img/picture8.9b0e1091.png";